import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, CircularProgress } from '@mui/material';
import InfiniteScroll from 'react-infinite-scroller';
import ThreeDotIcon from '../svg/ThreeDotIcon';
import FileContainer from './FileContainer';
import Header from './Header';
import { fetchResourcesByClassId } from '../service/resource.service';
import { API_LIMIT_DATA } from '../utils/constants';

const SelectedResources = forwardRef(
  ({ title, isStudent = false, classId, type, onBack, editResource, deleteResource }, ref) => {
    const [resources, setResources] = useState();
    const [offset, setOffset] = useState(1);
    const [hasMore, setHasMore] = useState();
    const [isLoading, setLoading] = useState(true);
    const [isDataLoading, setIsDataLoading] = useState(false);

    useImperativeHandle(ref, () => ({
      refreshData() {
        refetchResourceData();
      }
    }));

    const fetchResources = async () => {
      const res = await fetchResourcesByClassId(classId, API_LIMIT_DATA, offset, type);
      if (res) {
        setResources(res.results);
        setHasMore(res.results.length === API_LIMIT_DATA);
        setOffset(offset + 1);
      }
      setLoading(false);
    };

    const fetchNextData = async () => {
      if (hasMore) {
        const res = await fetchResourcesByClassId(classId, API_LIMIT_DATA, offset, type);
        if (res) {
          setResources((preResource) => [...preResource, ...res.results]);
          setHasMore(res.results.length === API_LIMIT_DATA);
          setOffset(offset + 1);
        }
        setIsDataLoading(false);
      }
    };

    const refetchResourceData = async () => {
      setLoading(true);
      const res = await fetchResourcesByClassId(classId, API_LIMIT_DATA, 1, type);
      if (res) {
        setResources(res.results);
        setHasMore(res.results.length === API_LIMIT_DATA);
        setOffset(1 + 1);
        setLoading(false);
      } else {
        setLoading(false);
      }
    };

    useEffect(() => {
      fetchResources();
    }, []);
    return (
      <>
        <Header title={title} onBack={onBack} />
        <Card style={{ marginTop: 15, maxHeight: '500px', overflowY: 'auto' }} id="scrollableCard">
          <CardContent>
            {isLoading ? (
              <div style={{ textAlign: 'center', padding: '15% 0' }}>
                <CircularProgress />
              </div>
            ) : (
              <InfiniteScroll
                pageStart={0}
                loadMore={() => {
                  if (hasMore && !isDataLoading) {
                    fetchNextData();
                    setIsDataLoading(true);
                  }
                }}
                hasMore={hasMore}
                getScrollParent={() => document.getElementById('scrollableCard')}
                loader={
                  <div className="loader" key={0}>
                    Loading ...
                  </div>
                }
                useWindow={false}
              >
                {resources.map((ru) => {
                  if (isStudent) {
                    return (
                      <FileContainer
                        id={ru.id}
                        key={ru.id}
                        file={ru.file}
                        title={ru.name}
                        type={ru.type}
                        date={ru.createdAt}
                        rightIcon={<ThreeDotIcon />}
                        onDownloadPress={() => {}}
                        onSharePress={() => {}}
                      />
                    );
                  }
                  return (
                    <FileContainer
                      id={ru.id}
                      key={ru.id}
                      file={ru.file}
                      title={ru.name}
                      type={ru.type}
                      date={ru.createdAt}
                      rightIcon={<ThreeDotIcon />}
                      onRenamePress={() => editResource(ru)}
                      onDeletePress={() => deleteResource(ru.id)}
                      onDownloadPress={() => {}}
                      onMoveCopyPress={() => {}}
                    />
                  );
                })}
              </InfiniteScroll>
            )}
          </CardContent>
        </Card>
      </>
    );
  }
);

SelectedResources.propTypes = {
  title: PropTypes.string,
  onBack: PropTypes.func,
  isStudent: PropTypes.bool,
  classId: PropTypes.string,
  type: PropTypes.string,
  editResource: PropTypes.func,
  deleteResource: PropTypes.func
};

export default SelectedResources;
